import { Pipe, PipeTransform } from '@angular/core';

const EPSILON = 0.000000001;

@Pipe({
  name: 'signedNumber'
})
export class SignedNumberPipe implements PipeTransform {
  transform(value: unknown): unknown {
    if (typeof value === 'number') {
      const sign =  !value || Math.abs(value) < EPSILON ? '' : value > 0 ? '+' : value < 0 ? '-' : '';
      return sign + Number(value);
    }
    if (typeof value === 'string') {
      if (!value) return value;
      const zero = value === '0' || Math.abs(Number(value)) < EPSILON;
      const sign = zero ? '' : value[0] === '-' ? '-' : '+';
      return sign + value;
    }
    return value;
  }
}
